export default __webpack_public_path__ + "static/media/glass-unaccept.e5a8dfb6.png";